var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pvd-container p-xxsmall-top"},[_c('p',{staticClass:"footnotes",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }